import { assetThumbnailUrl, assetCardThumbnailUrl } from '../../volc-asset/assetMedia'
import { toPublicMediaUrl, CDN_ORIGIN, LEGACY_OSS_ORIGIN } from '@/utils/publicMediaUrl'

// The 240px hover window uses a 480px CDN derivative, including extensionless images.
// Unsupported remote sources wait for an explicit full-screen request.
export function referenceHoverThumbnailUrl(value) {
  if (typeof value === 'string' && (value.startsWith('blob:') || value.startsWith('data:image/'))) return value
  return assetCardThumbnailUrl({ sourceUrl: value, assetType: 'Image' })
}

// Presentation only. Never store these derivatives on a generation reference object.
export function referenceThumbnailUrl(value, mediaType = 'image', { compact = false } = {}) {
  if (String(mediaType).toLowerCase() === 'image') return assetThumbnailUrl(value, { compact, knownImage: compact })
  if (String(mediaType).toLowerCase() !== 'video') return ''
  const original = toPublicMediaUrl(value)
  try {
    const url = new URL(original)
    if (![CDN_ORIGIN, LEGACY_OSS_ORIGIN].includes(url.origin) || url.search || url.hash ||
      url.username || url.password || !/\.(?:mp4|mov|m4v)$/i.test(url.pathname)) return ''
    return `${original}?x-oss-process=video/snapshot,t_0,f_jpg,w_${compact ? 64 : 640},h_0,m_fast`
  } catch (_) { return '' }
}
